/**
 * Pufien sepet ek davranışları.
 *
 * "+1 ekle" teşviki: temanın KENDİ artı butonuna tıklar
 * (`[ref="plusButton"]`, on:click="/increaseQuantity").
 * Böylece mevcut cart AJAX / CartUpdateEvent / morphSection akışına
 * hiç dokunmuyoruz — sıfır risk. Kendi fetch'imizi YAZMIYORUZ.
 */
(function () {
  function bind(root) {
    (root || document).querySelectorAll('[data-pf-plus-one]').forEach(function (btn) {
      if (btn.dataset.pfBound === '1') return;
      btn.dataset.pfBound = '1';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var row = btn.closest('tr') || btn.closest('.cart-items__table-row');
        if (!row) return;

        var plus = row.querySelector('[ref="plusButton"]');
        if (plus && !plus.disabled) {
          plus.click(); // temanın kendi mekanizması
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(); });
  } else {
    bind();
  }

  // Sepet morph'landıktan sonra yeni satırlara tekrar bağlan.
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
  document.addEventListener('cart:update', function () { bind(); });
  new MutationObserver(function () { bind(); }).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
